import { connectToChild } from 'penpal';
import { Connection } from 'penpal/lib/types';
import { env } from './env';

interface Methods {
    [index: string]: Function;
}

export function createIframeModal(
    frame: HTMLIFrameElement,
    onClose?: () => Promise<boolean | undefined>,
) {
    const wrapper = document.createElement('div');
    wrapper.style.cssText = `
        position: relative;
        width: calc(100vw - 100px);
        min-width: 1280px;
        height: calc(100vh - 80px);
        min-height: 604px;
        margin: 50px auto;
        background: rgb(255, 255, 255);
        display: block;
    `;

    const btn = document.createElement('div');
    btn.style.cssText = `
        font-size: 13px;
        width: 42px;
        height: 42px;
        text-align: right;
        position: absolute;
        right: -42px;
        top: 0px;
        background: no-repeat rgb(0, 0, 0);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    `;

    const btnIcon = document.createElement('img');
    btnIcon.src = 'https://st-gdx.dancf.com/gaodingx/34555636/design/20190509-142237-249d.png';
    btnIcon.style.cssText = 'display: block; width: 24px;';

    btn.appendChild(btnIcon);

    const modal = document.createElement('div');

    modal.style.cssText = `
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 1000;
    `;

    modal.className = 'gaoding-editor-iframe-dialog';

    wrapper.appendChild(btn);
    wrapper.appendChild(frame);

    modal.appendChild(wrapper);
    wrapper.appendChild(frame);

    const mask = document.createElement('div');

    mask.style.cssText = `
        position: fixed;
        inset: 0px;
        z-index: 999;
        background-color: rgb(0, 0, 0);
        opacity: 0.5;
    `;

    let isOpen = false;
    let overflowValue = '';

    function toggleScrollSwitch() {
        const dom: HTMLElement | null = document.querySelector('.gaoding-editor-iframe-dialog');
        if (!dom) return;
        if (isOpen) {
            overflowValue = document.documentElement.style.overflow;
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = overflowValue;
        }
    }

    async function close() {
        if (onClose) {
            const res = await onClose();
            if (res === false) return;
        }
        isOpen = false;
        toggleScrollSwitch();
        mask.parentElement?.removeChild(mask);
        modal.parentElement?.removeChild(modal);
    }

    function open() {
        if (isOpen) return;
        isOpen = true;
        document.body.appendChild(mask);
        document.body.appendChild(modal);
        toggleScrollSwitch();
    }
    btn.addEventListener('click', close);

    return {
        open,
        close,
    };
}

export function createConnect<T extends { [k: string]: any }>(options: {
    methods: Methods;
    appId: string;
    container?: string | HTMLElement;
    onClose?(): Promise<boolean | undefined>;
    css?: string;
}) {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = `
        display: block;
        width: 100%;
        height: 100%;
        ${options.css}
    `;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.className = 'gaoding-iframe';
    iframe.setAttribute('frameborder', '0');

    let child: Connection<T> | null = null;

    // let key = '';
    async function update(url: string, query?: { [k: string]: any }) {
        const q = Object.assign({}, query, { app_id: options.appId, v: env.VERSION });
        const uri = `${url}?${Object.entries(q)
            .filter(([_, v]) => v !== undefined)
            .map(([k, v]) => `${k}=${v}`)
            .join('&')}`;
        // if (key === uri) return;

        // key = uri;
        if (!query) {
            iframe.src = url;
            return;
        }
        iframe.src = uri;
        if (child) {
            child.destroy();
        }
        child = connectToChild<T>({
            iframe: iframe,
            methods: options.methods,
        });
    }

    let modal: { open(): void; close(): void } | null = null;
    if (!options.container) {
        modal = createIframeModal(iframe, options.onClose);
    }
    function insert() {
        if (modal) {
            return modal.open();
        }
        const parent =
            typeof options.container === 'string'
                ? document.body.querySelector(options.container)
                : options.container;
        if (!parent) throw new Error(`无效的 container ${options.container}`);
        parent.appendChild(iframe);
    }

    function remove() {
        if (modal?.close) {
            return modal.close();
        }
        if (iframe.parentElement) {
            iframe.parentElement.removeChild(iframe);
        }
    }

    function restetContainer(container: string | HTMLElement) {
        modal = createIframeModal(iframe, options.onClose);
        options.container = container;
    }

    return {
        remove,
        insert,
        update,
        iframe,
        restetContainer,
        async getService() {
            return child!.promise;
        },
    };
}
